import React, { useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import AuthService from 'services/AuthService';

interface PdfPreviewLoginProps {
  buildAuthRoute: (id?: string) => string;
}

const PdfPreviewLogin: React.FunctionComponent<PdfPreviewLoginProps> = ({ buildAuthRoute }) => {
  const history = useHistory();
  const location = useLocation();

  const { id } = useParams<any>();
  useEffect(() => {
    const checkAuthentication = async () => {
      const route = buildAuthRoute(id);
      const query = new URLSearchParams(location.search);
      const userName = query.get('user');
      if (!userName) {
        throw new Error("Missing 'user' query parameter.");
      }
      const password = query.get('password');
      if (!password) {
        throw new Error("Missing 'password' query parameter.");
      }
      await AuthService.login({ userName, password });
      history.push(route);
    };

    checkAuthentication();
  }, [id]);

  return <div>Loading...</div>;
};

export default PdfPreviewLogin;
